import $ from 'jquery';

export default function testimonialsSection() {
	const $html = $('html');
	const $window = $(window);
	const $scroller = $('html, body');

	$('.body_testimonials').each(function() {
		const $container = $(this);
		const $quotesContainer = $(this).find('.quotes');
		const $quotes = $(this).find('.quote');
		const $medias = $(this).find('.quote_media');
		const $prevArr = $container.find('.testimonials_arrows_previous');
		const $nextArr = $container.find('.testimonials_arrows_next');
		const numQuotes = $quotes.length;
		let currentIndex = 0;
		let interval;
		let animating = false;

		const intervalDuration = $container.attr('data-autoplay') * 1000
		if (intervalDuration) {
			interval = setInterval(() => {
				$nextArr.click()
			}, intervalDuration);
		}

		// $quotesContainer.height($quotes.eq(currentIndex).height());

		$quotes.filter(':not(:first)').add(
			$medias.filter(':not(:first)')
		).addClass('-hidden-right');

		$window.on('load resize', () => {
			const $animEls = $quotesContainer.add(
				$container.find('.quote, .quote_media')
			);
			let $quote = $quotes.eq(currentIndex);
			$animEls.css('transition', 'none')
			// $quotesContainer.height($quote.height());
			setTimeout(() => {
				$animEls.css('transition', '');
			}, 1000);
		});

		const changeSlide = delta => e => {
			if (animating) {
				return;
			}

			animating = true;

			// If it was a real click then clear the timer
			if (interval && e.originalEvent !== undefined) {
				clearInterval(interval);
			}

			let $quote = $quotes.eq(currentIndex);
			let $media = $medias.eq(currentIndex);
			$quotes.eq(currentIndex);

			// Keep the media the same height for it's respective slide, this
			// can't be set because of the DOM structure.
			// $media.height($media.height());

			$quote.add($media)
				.fadeOutTo(delta === -1 ? 'right' : 'left');

			currentIndex = ((currentIndex - delta) + numQuotes) % numQuotes;

			$quote = $quotes.eq(currentIndex);
			$media = $medias.eq(currentIndex);

			setTimeout(() => {
				$quote.add($media)
					.fadeInFrom(delta === -1 ? 'left' : 'right');
			}, 400);

			setTimeout(() => {
				animating = false
			}, 1000);

			// Set the height of the container to match the height of the current
			// quote
			// $quotesContainer.height($quote.height());
		};

		$prevArr.click(changeSlide(-1));
		$nextArr.click(changeSlide(1));
	});
};

$.fn.fadeInFrom = function(dir) {
	const $el = this;
	const otherDir = dir === 'right' ? 'left' : 'right'

	$el
		.css('transition', 'none')
		.removeClass('-hidden-' + otherDir)
		.addClass('-hidden-' + dir);

	setTimeout(() => {
		$el
			.css('transition', '')
			.removeClass('-hidden-' + dir);
	}, 100);

	return $el;
};

$.fn.fadeOutTo = function(dir) {
	return this.addClass('-hidden-' + dir);
};



// WEBPACK FOOTER //
// ./source/scripts/sections/testimonials.js